// pages/Home.js - Update the class names
import React from 'react';
import { Link } from 'react-router-dom';
import Lottie from 'lottie-react';
import pillAnimation from './jsons/taken.json';
import healthAnimation from './jsons/mother.json';
import './Home.css';

const Home = () => {
  return (
    <div className="home-page"> {/* Changed from home-container to home-page */}
      {/* Lottie Animations - Updated class names */}
      <div className="home-lottie-container home-lottie-top">
        <Lottie 
          animationData={pillAnimation} 
          loop 
          autoplay 
          className="home-lottie-icon"
        />
      </div>
      
      <div className="home-lottie-container home-lottie-bottom">
        <Lottie 
          animationData={healthAnimation} 
          loop 
          autoplay 
          className="home-lottie-icon"
        />
      </div>

      <div className="home-content">
        <h1 className="home-title">
          <span className="title-emoji">💊</span>
          MedTracker
          <span className="title-emoji">📱</span>
        </h1>
        
        <p className="home-subtitle">
        Keep track of your medications and  Never miss a dose again.
        </p>

        <div className="home-buttons">
          <Link to="/login" className="home-button primary pulse-animation">
            <span className="button-icon">🚀</span>
            Get Started
            <span className="button-icon">→</span>
          </Link>
          
          <Link to="/about" className="home-button secondary">
            <span className="button-icon">📖</span>
            Learn More
          </Link>
        </div>

       
      </div>
    </div>
  );
};

export default Home;